﻿import { setCookie, getCookie } from '../functions.js';
import { debounce } from '../functions.js';

window.addEventListener('load', () => {
    const $advertisement = document.getElementById('advertisement');

    if ($advertisement) {
        const $closeButton = $advertisement.querySelector('.delete');
        const identifier = $advertisement.dataset.identifier;
        const $cookieName = 'advertisement-' + identifier;
        const $cookieValue = getCookie($cookieName);
        const $html = document.documentElement;
        const adrect = $advertisement.getBoundingClientRect();
        let advertisementHeight = adrect.height + 5;
        const $navbar = document.getElementById('navbar');
        const $mainMenu = document.getElementById('mainmenu');
        const headrect = $navbar.getBoundingClientRect();
        let headerHeight = headrect.height;
        var $orderbar = document.getElementById('orderbar');
        let prevScroll = 0;
        const mq = window.matchMedia('(min-width: 1023px)');

        if ($cookieValue) {
            $advertisement.classList.remove('is-active');
        } else {
            $html.style.paddingTop = `${headerHeight + advertisementHeight}px`;
            $navbar.style.top = `${advertisementHeight}px`;
            $mainMenu.style.top = `${headerHeight + advertisementHeight}px`;

            if ($orderbar) {
                document.addEventListener('scroll', debounce(() => {
                    if (mq.matches) {
                        headerHeight = headrect.height;
                        if (prevScroll > window.scrollY) {
                            $orderbar.style.setProperty('top', `${headerHeight + advertisementHeight - 5}px`, 'important');
                        } else if (prevScroll < window.scrollY) {
                            $orderbar.style.setProperty('top', `${advertisementHeight}px`, 'important');
                        }
                        prevScroll = window.scrollY;
                    }
                }, 50));

            }

            window.addEventListener('resize', debounce(() => {
                headerHeight = headrect.height;
                advertisementHeight = adrect.height + 5;
                $html.style.paddingTop = `${headerHeight + advertisementHeight}px`;
                $navbar.style.top = `${advertisementHeight}px`;
                $mainMenu.style.top = `${headerHeight + advertisementHeight}px`;

                if ($orderbar) {
                    if (!mq.matches) {
                        $orderbar.style.removeProperty('top');
                    }
                }
            }, 100));
        }

        $closeButton.addEventListener('click', () => {
            $advertisement.classList.remove('is-active');
            $html.style.paddingTop = `${headerHeight}px`;
            $navbar.style.top = 0;
            $mainMenu.style.top = `${headerHeight}px`;

            setCookie($cookieName, true, 7);
            if ($orderbar) {
                $orderbar.style.removeProperty('top');
            }
        });
    }
});